module.exports = __webpack_public_path__ + "files/66a168507f2b640beae1bf0d3b52e0ef.png";